<template>
  <div>
    <CosInput
      :value="addressModal"
      placeholder="请选择"
      :view="view"
      :allowClear="true"
      @click="showModal"
      @change="handleChange"
    >
      <template #enterButton>
        <a-button>Custom</a-button>
      </template>
    </CosInput>
    <cos-modal v-model:visible="visible" title="地址选择" width="90%" height="80%" @ok="handleOk" :maskClosable="false">
      <Map
        @mapData="mapData"
        :editData="{
          geoPoint,
          address
        }"
        v-if="visible"
      ></Map>
    </cos-modal>
  </div>
</template>
<script lang="ts">
import Map from '@/components/Map/index.vue'
import { defineComponent, ref, watch } from 'vue'
import type { SystemSetting } from '@/types/systemSetting'
import { Form } from 'ant-design-vue'
export default defineComponent({
  components: {
    Map
  },
  props: {
    address: {
      type: String,
      default: ''
    },
    geoPoint: {
      type: Object,
      default: () => {
        return {
          longitude: '',
          latitude: ''
        }
      }
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const editData = ref<any>({})
    const addressModal = ref('')
    const checkMap: any = ref({
      address: '',
      latAndLong: []
    })
    const formItemContext = Form.useInjectFormItemContext()
    editData.value.latAndLong = []
    watch(
      () => props.address,
      () => {
        if (props.address) {
          addressModal.value = props.address
        } else {
          addressModal.value = ''
        }
        const { longitude, latitude } = props.geoPoint
        if (longitude && latitude) {
          editData.value.latAndLong = [Number(longitude), Number(latitude)]
        } else {
          editData.value.latAndLong = []
        }
      },
      { deep: true, immediate: true }
    )

    const visible = ref<boolean>(false)

    const showModal = () => {
      if (props.view) {
        return
      }
      visible.value = true
    }
    const latAndLongModal = ref([])
    const handleOk = () => {
      visible.value = false
      const { address, latAndLong } = checkMap.value
      emit('update:address', address)
      emit('update:geoPoint', {
        longitude: latAndLong[0],
        latitude: latAndLong[1]
      })
      formItemContext.onFieldChange()
    }
    const mapData = (data: SystemSetting.MapData) => {
      checkMap.value = {
        address: data.address,
        latAndLong: data.latAndLong?.map((value: number) => {
          return value
        })
      }
    }
    const handleChange = (e: any) => {
      const { value } = e.target
      if (!value && e.type !== 'change') {
        // addressModal.value = ''
        // editData.value.latAndLong = []
        emit('update:address', '')
        emit('update:geoPoint', {
          longitude: -9,
          latitude: -9
        })
      }
    }
    return {
      visible,
      showModal,
      handleOk,
      mapData,
      addressModal,
      latAndLongModal,
      editData,
      handleChange
    }
  }
})
</script>
<style scoped lang="scss">
.sameInput {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d8dfe4;
  border-radius: 4px;
  height: 32px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  padding: 0 10px;
}
</style>
